import { Component, OnInit, Input } from '@angular/core';
import { Customer } from '../../../customer/customer.model';
import { AdminDispatcher } from '../../../../store/admin-store/admin-dispatcher';
import { SidenavService } from '../../../services/sidenav.service';
import { MatMiniFabButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-advanced-subscription-features',
    templateUrl: './advanced-subscription-features.component.html',
    styleUrls: ['./advanced-subscription-features.component.scss'],
    imports: [MatMiniFabButton, MatIcon, NgIf, MatButton, TranslatePipe]
})
export class AdvancedSubscriptionFeaturesComponent implements OnInit {
  /**
   * @property Property to store customer information
   */
  @Input() customer: Customer;
  /**
   *
   * @property Property to store expanded feature
   */
  public expanded: boolean;

  /**
   * @property Property to store customer information
   */
  @Input() vehicleDetails: object;

  /**
   * @property Property to store the vehicle association active GUID
   */
  @Input() vehicleAssociationActiveGuid: string;

  constructor(
    private adminDispatcher: AdminDispatcher,
    private sidenav: SidenavService,
  ) { }

  /**
  * @function ngOnInit Method to Initializes the component and perform initial operations
  */
  ngOnInit() {
  }

  /**
   * @method toggleSidenav toggles the side nav
   **/
  public toggleSidenav(updateAttribute: string): void {
    let _value: any;
    if (updateAttribute === 'remove-vehicle') {
      _value = {
        customer: this.customer,
        vehicle: this.vehicleDetails,
        vehicleAssociationActiveGuid: this.vehicleAssociationActiveGuid
      };
    }

    this.adminDispatcher.setUpdateInfo('account', updateAttribute, _value, this.customer['lastUpdateDate']);
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }

  /**
   * @function expandAdvancedFeatures changes the value of expanded to show advanced features
   */
  public expandAdvancedFeatures(): void {
    this.expanded = !this.expanded;
  }

}
